import React, { Suspense, useState } from "react";
import { renderRoutes } from "react-router-config";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { LinearProgress } from "@material-ui/core";
import NavBar from "./NavBar";
import TopBar from "./TopBar";
import CssBaseline from "@mui/material/CssBaseline";
import { SecureGate } from "src/components";

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: "100vh",
    display: "flex",
    "@media all and (-ms-high-contrast:none)": {
      height: 0, // IE11 fix
    },
  },
  content: {
    paddingTop: 64,
    flexGrow: 1,
    maxWidth: "100%",
    // overflowX: "hidden",
    backgroundColor: "#F5F6F7",
    paddingLeft: 0,
    transition: theme.transitions.create("padding", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentDrawerOpen: {
    paddingTop: 64,
    flexGrow: 1,
    maxWidth: "100%",
    // overflowX: "hidden",
    backgroundColor: "#F5F6F7",
    paddingLeft: 256,
    transition: theme.transitions.create("padding", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
}));

function Full({ route }) {
  const classes = useStyles();
  const [onToogleMenu, setToogleMenu] = useState(true);

  return (
    <>
      <SecureGate />
      <Suspense fallback={<LinearProgress />}>
        <TopBar onToogleMenu={() => setToogleMenu(!onToogleMenu)}></TopBar>
        <NavBar onToogleMenu={onToogleMenu} />
        <div className={classes.container}>
          <div
            className={
              onToogleMenu ? classes.contentDrawerOpen : classes.content
            }
          >
            <CssBaseline>{renderRoutes(route.routes)}</CssBaseline>
          </div>
        </div>
      </Suspense>
    </>
  );
}

Full.propTypes = {
  route: PropTypes.object,
};

export default Full;
